import { useEffect, useRef } from "react";
import { TutorialListProps } from "./types";
import { cn } from "@/lib/utils";

export function TutorialList(props: TutorialListProps) {
  const listRef = useRef<HTMLUListElement>(null);

  const activateStrippable = (li: HTMLLIElement) => {
    li.addEventListener("click", () => {
      li.style.textDecoration = li.style.textDecoration === "line-through" ? "none" : "line-through";
    });
  };

  useEffect(() => {
    if (props.strippable === "true" && listRef.current) {
      const liItems = listRef.current.querySelectorAll("li");
      liItems.forEach((li) => activateStrippable(li));
    }

    return () => {
      if (listRef.current) {
        const liItems = listRef.current.querySelectorAll("li");
        liItems.forEach((li) => li.replaceWith(li.cloneNode(true)));
      }
    };
  }, [props.strippable]);

  return (
    <ul
      ref={listRef}
      className={cn(
        "mt-2 list-disc space-y-2 self-start pl-5 text-cede-text-primary [&_*]:text-base",
        props.strippable ? "[&_*]:cursor-pointer" : "[&_*]:cursor-default",
      )}
    >
      {props.children}
    </ul>
  );
}
